export default function IconEducation({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M18.8421 10.3333V17.6251L12 22L5.15789 17.6251V10.3333M22 7.71432L12 1.5L2 7.71432L12 13.6667L22 7.71432ZM22 7.71432V13.6666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
